import './App.css';
import { SidebarProvider } from './pages/components/SidebarContext';
import Sidebar from './pages/components/Sidebar';
import Navbar from './pages/components/Navbar';
import React, { useState } from "react";
import { useRef } from 'react';
import { ModalContext } from "./pages/context/ModalContext";

function App({ children }) {
  // 🟢 buat penampung data dari Navbar
  const [triggerData, setTriggerData] = useState(null);

  // 🟢 fungsi yang dipanggil dari Navbar
  const handleOpenDetail = (data) => {
    console.log("Trigger dari Navbar:", data);
    setTriggerData(data); // simpan data biar halaman lain bisa baca
  };

  return (
      <SidebarProvider>
        <div className="layout">
            <Sidebar />
            <main className="main-content">
                
                  <Navbar />
                  <div className="container" style={{ marginTop: "80px" }}>
                    {children}
                  </div>
            </main>
        </div>
      </SidebarProvider>
  );
}

export default App;
